import React from 'react'
import './Experience.css'

const roles = [
 ['2026 – Present','Founder & Full-Stack Software Engineer','NEXORA','Architecture, full-stack delivery, APIs, databases, Linux deployment and product strategy.'],
 ['2025 – Present','Technology Officer','Provincial Government Haut-Uele','Digital transformation, IT strategy, cybersecurity and public-service modernization.'],
 ['2023 – 2026','IT Manager & Data Analyst','Assistance Sociale','Systems administration, technical support, reporting and workflow automation.'],
 ['2023 – 2024','Software Engineer & Data Analyst','Afrinovator','Data-driven applications, dashboards and automated reporting.'],
 ['2023 – 2024','Full-Stack Software Engineer','Visual Communication Agency','Responsive applications, REST APIs, authentication and real-time features.'],
 ['2022 – 2023','Full-Stack Software Engineer','E-life Technologies','CRM platform, sales tracking, dashboards and workflow automation.'],
 ['2022','Network Operations Intern','Vodacom Congo','Network monitoring, troubleshooting and operational reporting.'],
 ['2021','Full-Stack Software Engineer','Legacy Store','Inventory, sales management and reporting automation.']
]

const Experience = () => (
 <section className='experience-section site-shell' id='Experience'>
  <div className='section-header'><span className='section-eyebrow'>Professional experience</span><h2 className='section-title'>Experience across software, data and infrastructure</h2></div>
  <div className='timeline'>{roles.map(([date,title,company,description]) => <article className='timeline-item' key={`${company}-${date}`}><div className='timeline-dot'/><time>{date}</time><div><h3>{title}</h3><strong>{company}</strong><p>{description}</p></div></article>)}</div>
 </section>
)
export default Experience
